export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8279.ab4b3578.jpg";